import actions from "./actions.js";
import getters from "./getters.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            approveList: [],
            waitingFeedAnswers : [],
            disasterCrisisIsApproved: false,
            checkAnswerRules : [],
            approveReplyResponse : null,
            isSent : true,
        };
    },
    getters,
    actions,
    mutations
};